import '#/PublicPath';

import { App } from './app';
import { renderClientNoSsr } from './rendering/client/renderClientNoSsr';
import { getRouteObjects } from './routing/route-objects';

renderClientNoSsr({
  Component: App,
  routeObjects: getRouteObjects(),
});
